export var ISSUE_NUMBER_PATTERN = /^[1-9]\d*$/;
// Mirrors the backend ceiling (IssueNumbers.MAX): above it the backend refuses the number.
export var MAX_ISSUE_NUMBER = 999999;
export var isValidIssueNumber = function (input) {
    var trimmed = input.trim();
    return (ISSUE_NUMBER_PATTERN.test(trimmed) && Number(trimmed) <= MAX_ISSUE_NUMBER);
};
